import DataTable from "../../Reusable/DataTable";
import NACell from "../../Reusable/DataTable/NACell";
import APIS from "../../../constant/EndPoint";
import TableActionButton from "../../Reusable/TableActionButton";

const ReferenceTypeList = () => {

  const defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },

    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    },
  ];
  return (
    <DataTable
      url={APIS.REFERENCE_TYPE}
      queryKey={"reference-type"}
      columns={defaultColumns}
      addNewPagePath={"/create-reference-type"}
      tableName={"Reference Type"}
    />
  );
};

export default ReferenceTypeList;
